import {getSearchParams,setSearchParams} from 'helper/url';
// 引入组件
import './components/list';
// 引入样式
import './css/list.less';
import './css/shop.less';
//批量引入xtpl目录下的less
const req1 = require.context('./xtpl/list/', true, /\.less$/);
req1.keys().forEach(key=>req1(key));
const req2 = require.context('./xtpl/shop/', true, /\.less$/);
req2.keys().forEach(key=>req2(key));

// 配置retcode
window.__WPO&&window.__WPO.setConfig({
  sample: 1,
  spmId: 'marketplace.shopproducts'
});

//获取URL参数
const {pageIndex=1,pageSize=10,keywords,filter} = getSearchParams();
//获取全局默认参数
let {baseURL='',category={},filterTags,products,curPage=1,totalPage=0,totalRecords=0,supplier={}} = window.MARKET_CONFIG;
if(baseURL) baseURL = '//'+baseURL;
//初始化选中项
let showAllRegions = false;
filter&&filterTags.forEach(item=>{
  let {filterKey,fields}= item;
  const selectedItem = filter[filterKey];
  if(filterKey=='imageReleaseRegion') showAllRegions = fields.length<5;
  if(!selectedItem) return;
  fields.forEach(field=>{
    field.selected = selectedItem.indexOf(field.filterValue)>-1;
  });
});

// 初始化全局唯一实例
window.vm = new Vue({
  el: '#app',
  data:{
    baseURL,
    filterTags,
    showAllRegions,   //仅展示5个，隐藏其余

    //查询数据
    queryData:{
      categoryId:category.id,
      pageIndex,
      pageSize:10, //每页显示10条
      keywords, 
      supplierId:supplier.id
    },    
    selectedFilterNum:0, //选择过滤条件的个数

    clientRender:false, // 渲染方式，默认采用服务端渲染

    //商品列表结果
    listResult:{
      curPage,
      totalPage,
      totalRecords,
      products
    },
    //商品列表价格
    productPricesList:[]
  },
  computed:{
    //提取商品code，供询价使用
    productCodes:function(){
      const {products} = this.listResult;
      const codes = products.map((item)=>item.productcode||item.code).join(',');
      return {codes};
    },
    listData:function(){
      let filter = {},selectedFilterNum=0;
      this.filterTags.forEach(item=>{
        item.fields.forEach(fieldItem=>{
          if(!fieldItem.selected) return;
          filter[item.filterKey] = filter[item.filterKey]||[];
          filter[item.filterKey].push(fieldItem.filterValue);
          selectedFilterNum++
        })
      });
      this.selectedFilterNum = selectedFilterNum;
      let queryListData = {...this.queryData,filter};
      //序列化array类型
      for (let key in queryListData) {
        if (!queryListData.hasOwnProperty(key)) continue;
        let value = queryListData[key];
        if(key=='filter'){
          if(Object.keys(value).length==0){
            queryListData.filter = null;
          }else{
            queryListData[key] = JSON.stringify(value)
          }
        }
      }
      setSearchParams({...queryListData,categoryId:null,pageSize:null});  //categoryId 不通过queryParams传递    
      return queryListData;
    }
  },
  methods:{
    clearFilters:function(){
      const _tags = $.extend(true,[],this.filterTags);
      _tags.forEach(item=>{
        item.fields.forEach(fieldItem=>{
          fieldItem.selected = false;
        })
      });
      this.filterTags = _tags;
    },
    changePageIndex:function(size){
      this.clientRender = true;
      this.queryData.pageIndex=size
    }
  }
});

//当筛选条件变化时，重置当前页码
window.vm.$watch('filterTags',function(){
  this.clientRender = true;
  vm.queryData.pageIndex = 1;
},{
  deep: true
});


// WEBPACK FOOTER //
// ./src/shop_products.js